import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const TestimoniolList = () => {
  const [productData, setProductData] = useState([]);
  const [open1, setOpen1] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const superuserId = localStorage.getItem("is_superuser");
  const storeId = localStorage.getItem("store_id");
  const [searchQuery, setSearchQuery] = useState("");
  // Add category Name start
  const [name, setName] = useState(null);
  const [profile, setProfile] = useState("");
  const [image, setImage] = useState("");
  const [message, setMessage] = useState("");
  const [url, setUrl] = useState("");
  const [company, setCompany] = useState("");
  const [position, setPosition] = useState("");
  // Add category Name End
  const [ids,setIds]=useState(null)

  const submitCategory = () => {
    const fd = new FormData();
    fd.append("store_id", storeId);
    fd.append("name", name);
    fd.append("client_profile", profile);
    fd.append("image", image);
    fd.append("message", message);
    fd.append("url", url);
    fd.append("company", company);
    fd.append("position", position);
    ids === null ?
    axios
      .post(
        `https://app1.crazzyhub.com/api/admin/multivendor-web-testimonial-admin/`,
        fd,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        toast.success(response.data.msg);
        handleClose1();
        testinomiolDataList();
      })
      .catch((error) => {
        console.log("error page", error.response);
        console.log(error);
      })
      :
      axios
      .put(
        `https://app1.crazzyhub.com/api/admin/multivendor-web-testimonial-admin/?id=${ids}&store-id=${storeId}`,
        fd,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        toast.success(response.data.msg);
        handleClose1();
        testinomiolDataList();
      })
      .catch((error) => {
        console.log(error);
      })

  };
  const previousData = () => {
    setPage(page - 1);
  };
  const nextData = () => {
    setPage(page + 1);
  };

  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);

  const testinomiolDataList = () => {
    axios
      .get(
        `https://app1.crazzyhub.com/api/admin/multivendor-web-testimonial-admin/?store_id=${storeId}`,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setProductData(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  useEffect(() => {
    testinomiolDataList();
  }, []);

  const EditFunction = (row) => {
    setIds(row?.id)
    setName(row?.name);
    setCompany(row?.company);
    setMessage(row?.message);
    setPosition(row?.position);
    setProfile(row?.client_profile);
    setUrl(row?.url);
  };

  const hangleCancel = () => {
    setName("");
    setCompany("");
    setMessage("");
    setProfile("");
    setUrl("");
    setIds(null)
    setPosition("");
    handleClose1();
    testinomiolDataList();
  };

  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            Manage Testimoniol List
          </p>
        </div>
        <div className="p-2 pt-5">
          <Button variant="outlined" size="small" onClick={handleOpen1}>
            + Add Testimoniol
          </Button>
        </div>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-2">
          <span className="flex  gap-3">
            {/* <CustomIconButton>
              <FilterAlt onClick={handleOpen} className="!text-black" />
            </CustomIconButton> */}
            <input
              type="text"
              value={searchQuery}
              className="!border-3 !border-black !w-72 mx-3 px-2 rounded-md py-1"
              placeholder="search"
              style={{ border: "1px solid black" }}
              onChange={(event) => setSearchQuery(event.target.value)}
            />
          </span>
          <span>
            <div className="text-red-500 mx-3">
              {superuserId === "true" ? (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleOpen1}
                >
                  <AddIcon />
                  Add Category
                </Button>
              ) : null}
              <Modal
                open={open1}
                onClose={handleClose1}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
              >
                <Box
                  sx={{ ...style, width: 850 }}
                  className="rounded-2xl !border-0"
                >
                  <div
                    id="child-modal-title "
                    className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
                  >
                   {ids === null ? "Add Testimoniol" : "Update Testimoniol"} 
                  </div>
                  <div className="flex justify-between">
                    <div className="w-[48%]">
                      <div>Name : </div>
                      <TextField
                        size="small"
                        value={name}
                        onChange={(event) => setName(event.target.value)}
                        id="outlined-basic"
                        className="!w-[100%] !mt-1"
                      />
                      <div className="mt-2">Image : </div>
                      <TextField
                        onChange={(event) => setImage(event.target.files[0])}
                        id="outlined-basic"
                        type="file"
                        size="small"
                        className="!w-[100%] !mt-1"
                      />
                      <div className="mt-2">Url : </div>
                      <TextField
                        value={url}
                        onChange={(event) => setUrl(event.target.value)}
                        id="outlined-basic"
                        size="small"
                        className="!w-[100%] !mt-1"
                      />
                    </div>
                    <div className="w-[48%]">
                      <div className="">Position : </div>
                      <TextField
                        value={position}
                        onChange={(event) => setPosition(event.target.value)}
                        id="outlined-basic"
                        size="small"
                        className="!w-[100%] !mt-1"
                      />
                      <div className="mt-2">Company : </div>
                      <TextField
                        value={company}
                        onChange={(event) => setCompany(event.target.value)}
                        id="outlined-basic"
                        size="small"
                        className="!w-[100%] !mt-1"
                      />
                      <div className="mt-2">Client Profile : </div>
                      <TextField
                        value={profile}
                        onChange={(event) => setProfile(event.target.value)}
                        id="outlined-basic"
                        size="small"
                        className="!w-[100%] !mt-1"
                      />
                    </div>
                  </div>
                  <div className="mt-2">Message : </div>
                  <textarea
                    placeholder="Type Message"
                    className="border border-gray-400 px-2 w-full rounded"
                    value={message}
                    onChange={(event) => setMessage(event.target.value)}
                    rows={"3"}
                  ></textarea>
                  <br />
                  <Button
                    onClick={hangleCancel}
                    variant="contained"
                    color="warning"
                    className="!py-2 !mt-3"
                  >
                    CANCEL
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    className="!py-2 !px-5 !font-bold !mt-3 !float-right"
                    onClick={submitCategory}
                  >
                    {ids===null ? "ADD" : "UPDATE"}
                  </Button>
                </Box>
              </Modal>
            </div>
          </span>
        </div>
        <TableContainer
          component={Paper}
          // sx={{  }}
          sx={{ width: "100%", maxHeight: 440 }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {/* <TableCell className="!text-left !p-2">
                  <Checkbox className="!m-0 !text-black" />
                </TableCell> */}
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  SR. NO.
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  NAME
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  POSITION
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  COMPANY
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  CLIENT PROFILE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  IMAGE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  URL
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  MESSAGE
                </TableCell>
                <TableCell
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              {productData &&
                productData?.map((row, index) => (
                  <TableRow key={row.id} className="!text-slate-700">
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.name ? row?.name : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {" "}
                      {row?.position ? row?.position : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.company ? row?.company : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.client_profile ? row?.client_profile : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.image ? (
                        <img src={row?.image} className="h-8 mx-auto w-8" />
                      ) : (
                        "--"
                      )}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.url ? row?.url : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.message ? row?.message : "--"}
                    </TableCell>

                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {/* <DeleteIcon className="!text-xl !text-red-600 !cursor-pointer" /> */}
                      <button onClick={handleOpen1}>
                        <BorderColorIcon
                          className="!text-xl !cursor-pointer !text-green-600"
                          onClick={() => EditFunction(row)}
                        />
                      </button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div
          className="!float-right relative bg-white w-[100%] mx-auto bottom-0 right-0 py-3 border-t-2 border-gray-400 !flex-col !justify-end !items-center"
          style={{ marginRight: "0px" }}
        >
          <button onClick={nextData} className="!float-right">
            <ArrowForwardIosIcon />
          </button>
          <button onClick={previousData} className="float-right">
            <ArrowBackIosIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestimoniolList;
